import { render, staticRenderFns } from "./MoveToAreaDialog.vue?vue&type=template&id=19805084&scoped=true&"
import script from "./MoveToAreaDialog.ts?vue&type=script&lang=ts&"
export * from "./MoveToAreaDialog.ts?vue&type=script&lang=ts&"
import style0 from "./MoveToAreaDialog.vue?vue&type=style&index=0&id=19805084&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19805084",
  null
  
)

export default component.exports